import logo from "@/assets/nexstarMG_logo.webp";
import { LogoImg, LogoLink } from "./Logo.elements";

export const Logo = () => (
    <div></div>
  // <LogoLink to="/">
  //   <LogoImg src={logo} alt="Logo" />
  // </LogoLink>
);
